import React, { Component, Fragment } from 'react'
import cn from 'classnames'
import { NavLink } from 'react-router-dom'
import FaListUi from 'react-icons/lib/fa/list-ul'

import ProfileSVG from 'app/components/SVGS/Profile'
import HeartSVG from 'app/components/SVGS/Heart'
import LogoutSVG from 'app/components/SVGS/Logout'
import UserAvatar from 'app/components/UserAvatar'
import { getOrganizationDomainFromUrl } from 'helpers/urlHelper'

import * as ROLES from 'app/constants/roles'

import './style.scss'
import StoryIcon from 'app/components/SVGS/StoryIcon'

export const bc = 'profile-dropdown'

class ProfileDropdown extends Component {
  state = {
    isOpen: false,
  }

  onBodyClick = event => {
    if (!event.target.closest(`.${bc}`)) {
      this.setState({
        isOpen: false,
      })
    }
  }

  componentDidMount() {
    document.body.addEventListener('click', this.onBodyClick)
  }

  componentWillUnmount() {
    document.body.removeEventListener('click', this.onBodyClick)
  }

  renderLogout = () => {
    const { t, onLogout } = this.props
    const orgName = getOrganizationDomainFromUrl(document.location.hostname)

    if (orgName === 'mondelez' || orgName === 'mondelezinternational') {
      return null
    }

    return (
      <span className={`${bc}__link`} onClick={onLogout}>
        <LogoutSVG />
        {t('Logout')}
      </span>
    )
  }

  render() {
    const { t, avatar, userProfile, roleName, roles, switchRole, isStoryActivatedForOrganization } = this.props

    return (
      <div
        id="profile-dropdown"
        className={bc}
        onClick={() => this.setState({ isOpen: !this.state.isOpen })}
        role="presentation"
      >
        <UserAvatar
          className={cn(`${bc}__avatar-wrapper`, {
            [`${bc}__avatar-wrapper--open`]: this.state.isOpen,
          })}
          initialClassName={`${bc}__initials`}
          avatar={avatar}
          userName={userProfile.get('firstName')}
          userLastName={userProfile.get('lastName')}
          userEmail={userProfile.get('email')}
        />
        <div
          className={cn(`${bc}__arrow`, {
            [`${bc}__arrow--open`]: this.state.isOpen,
          })}
        />
        {this.state.isOpen && (
          <div className={`${bc}__content`}>
            {roles.map(
              (role, index) =>
                role.get('name') !== roleName && (
                  <span
                    key={index}
                    className={`${bc}__link ${bc}__link--change-role`}
                    onClick={() => switchRole(index)}
                  >
                    {t(ROLES.ROLE_MENU_NAMES[role.get('name')])}
                  </span>
                )
            )}
            {roleName === ROLES.USER && (
              <Fragment>
                <NavLink to="/favorite-activities" className={`${bc}__link`}>
                  <HeartSVG
                    svgProps={{
                      style: {
                        marginRight: 6,
                      },
                    }}
                  />
                  {t('Favorite Activities')}
                </NavLink>
                {isStoryActivatedForOrganization && (
                  <NavLink to="/stories" className={`${bc}__link`}>
                    <StoryIcon width={14} />
                    {t('My Stories')}
                  </NavLink>
                )}
                <NavLink to="/completed-pro-tracks" className={`${bc}__link`}>
                  <FaListUi />
                  {t('Completed ProTracks')}
                </NavLink>
                <NavLink to="/profile" className={`${bc}__link`}>
                  <ProfileSVG />
                  {t('Profile Settings')}
                </NavLink>
              </Fragment>
            )}
            {this.renderLogout()}
          </div>
        )}
      </div>
    )
  }
}

export default ProfileDropdown
